import React from "react";

interface NodeIconProps {
  type: "folder" | "folder-open" | null; // null for leaf nodes
  showButton?:boolean;
  onClick?:any
}

const NodeIcon: React.FC<NodeIconProps> = ({ type,showButton,onClick }) => {
  // Decide what symbol to show
  if (!showButton) return null;
  const symbol = type === "folder" ? "+" : "–";
  console.log('onclick',onClick)

  return (
    <span
    onClick={onClick}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "20px",
        height: "20px",
        border: "1px solid #6F7E8C",
        borderRadius: "4px",          // Rounded corners for button look
        background: "#f9f9f9",        // Light background
        fontWeight: "bold",
        fontSize: "14px",
        color: "#6F7E8C",
        cursor: "pointer",
        userSelect: "none"
      }}
      
    >
      {symbol}
    </span>
  );
};

export default NodeIcon;
